document.addEventListener("DOMContentLoaded", function () {
  const tabSections = document.querySelectorAll(".featured-collections-tabs");

  tabSections.forEach(section => {
    const buttons = section.querySelectorAll(".tab-btn");
    const contents = section.querySelectorAll(".tab-content");

    const swipers = {};
    const prevBtn = section.querySelector(".collection-tabs-button-prev");
    const nextBtn = section.querySelector(".collection-tabs-button-next");


    function updateNav(swiper) {
      if (!swiper) return;

    
      if (swiper.isBeginning) {
        prevBtn.classList.add("disabled");
      } else {
        prevBtn.classList.remove("disabled");
      }

  
      if (swiper.isEnd) {
        nextBtn.classList.add("disabled");
      } else {
        nextBtn.classList.remove("disabled");
      }
    }


    contents.forEach(content => {
      const swiperEl = content.querySelector(".product-swiper");
      if (swiperEl) {
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 4,
          spaceBetween: 20,
          breakpoints: {
            320: {
              slidesPerView: 1.5,
              pagination: {
                el: content.querySelector(".collection-tabs-pagination"),
                clickable: true,
              }
            },
            768: {
              slidesPerView: 2,
              pagination: {
                el: content.querySelector(".collection-tabs-pagination"),
                clickable: true,
              }
            },
            1024: { slidesPerView: 4 }
          },
          on: {
            init(sw) {
              updateNav(sw);
            },
            slideChange(sw) {
              updateNav(sw);
            },
            reachBeginning(sw) {
              updateNav(sw);
            },
            reachEnd(sw) {
              updateNav(sw);
            }
          }
        });
        swipers[content.id] = swiper;
      }
    });

    
    buttons.forEach(btn => {
      btn.addEventListener("click", () => {
        buttons.forEach(b => b.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        btn.classList.add("active");
        const target = section.querySelector(`#${btn.dataset.tab}`);
        target.classList.add("active");
        const swiper = swipers[target.id];
        if (swiper) {
          swiper.slideTo(0, 0);
          updateNav(swiper);
        }
      });
    });

   
    prevBtn.addEventListener("click", () => {
      const activeTab = section.querySelector(".tab-content.active");
      if (activeTab) {
        const swiper = swipers[activeTab.id];
        swiper.slidePrev();
        updateNav(swiper);
      }
    });

    nextBtn.addEventListener("click", () => {
      const activeTab = section.querySelector(".tab-content.active");
      if (activeTab) {
        const swiper = swipers[activeTab.id];
        swiper.slideNext();
        updateNav(swiper);
      }
    });

    const activeTab = section.querySelector(".tab-content.active");
    if (activeTab && swipers[activeTab.id]) {
      updateNav(swipers[activeTab.id]);
    }
  });
});
